module.exports = __webpack_public_path__ + "static/media/equalizer.4524b5bf.svg";